export default {
    stats: "stats",
    talents: "talents",
    items: "items",
    legendaries: "legendaries",
    covenants: "covenants",
};
